import React from "react";
import type { QueueState } from "../../services/queue.service";

interface Props {
  state: QueueState;
  size?: "sm" | "md";
}

const CONFIG: Record<QueueState, { label: string; pill: string; dot: string }> = {
  waiting:     { label: "Waiting",     pill: "bg-cyan-50 text-cyan-700 border border-cyan-200",     dot: "bg-cyan-500" },
  in_progress: { label: "In Progress", pill: "bg-amber-50 text-amber-700 border border-amber-200",  dot: "bg-amber-500" },
  seen:        { label: "Seen",        pill: "bg-green-50 text-green-700 border border-green-200",  dot: "bg-green-500" },
  left:        { label: "Left",        pill: "bg-slate-100 text-slate-500 border border-slate-200", dot: "bg-slate-400" },
  deferred:    { label: "Deferred",    pill: "bg-purple-50 text-purple-700 border border-purple-200", dot: "bg-purple-500" },
  rejected:    { label: "Rejected",    pill: "bg-red-50 text-red-600 border border-red-200",         dot: "bg-red-500" },
};

export const QueueStateBadge: React.FC<Props> = ({ state, size = "md" }) => {
  const cfg = CONFIG[state] ?? CONFIG["waiting"];
  const text = size === "sm" ? "text-[10px] px-2 py-0.5" : "text-xs px-2.5 py-1";

  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full font-medium ${cfg.pill} ${text}`}>
      <span className={`h-1.5 w-1.5 rounded-full flex-shrink-0 ${cfg.dot}`} />
      {cfg.label}
    </span>
  );
};
